$(() => {
  $('.new_doorkeeper_application, .edit_doorkeeper_application').find('[multiple=multiple]').select2()
})
